/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatoreStatoAccessoDTO { 
    keycloak_abilitato?: boolean;
    brute_force_bloccato?: boolean;
    tentativi_falliti?: number;
    ultimo_tentativo_fallito?: string;
}

